import {components, fetchApi} from "@mbj-front-monorepo/data-access";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";


export const useGetAllNoteResEmpBySearch = (id:number)=>{
  const promise = () => fetchApi("/api/notes_results_employees", {method:'get', query:{ResultsSearch:id+""}});
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["notes_results_emp", { id }], promise, {
    enabled: id!==0,
  });
}

export const usePostNewNotEmployee = ()=>{
  const queryClient = useQueryClient();
  return useMutation(
    (data:components["schemas"]["NotesResultsEmployee-notesresultsemp.post"]) => {
      return fetchApi("/api/notes_results_employees", {
        method: "post",
        json: data,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notes_results_emp"]);
        toast.success("Note enregistrée", {});
      },
      onError: (error: any) => {
        toast.error("Erreur : " + error.message, {});
      },
    }
  );
}

export const usePutNewNotEmployess = ()=>{
  const queryClient = useQueryClient();
  return useMutation(
    (data: {id:number, datas:components["schemas"]["NotesResultsEmployee-notesresultsemp.write"] }) => {
      return fetchApi("/api/notes_results_employees/{id}", {
        method: "put",
        params:{id:data.id+""},
        json: data.datas,
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notes_results_emp"]);
        toast.success("Note modifiée", {});
      },
      onError: (error: any) => {
        toast.error("Erreur : " + error.message, {});
      },
    }
  );
}

export const useDeleteNewNotEmployess = ()=>{
  const queryClient = useQueryClient();
  return useMutation(
    (id:number) => {
      return fetchApi("/api/notes_results_employees/{id}", {
        method: "delete",
        params: {id:id+""},
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["notes_results_emp"]);
        toast.success("Note supprimée", {});
      },
      onError: (error: any) => {
        toast.error("Erreur : " + error.message, {});
      },
    }
  );
}
